import { GlobalToken, theme } from 'antd'
import { CSSInterpolation } from '@ant-design/cssinjs'

export const genLayoutStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => {
  // const a = theme.getDesignToken()
  // console.log('token', JSON.stringify(token))
  return [
    {
      [`.${prefixCls}`]: {
        height: '100%',

        [`&.collapsed`]: {
          [`.slider`]: {
            width: 52,

            [`.logo h1`]: {
              fontSize: 0,
              paddingLeft: 10,
            },

            //
            '.ant-menu .ant-menu-item .ant-menu-item-icon': {
              verticalAlign: '-0.3em',
            },
            '.ant-menu-inline-collapsed >.ant-menu-item, :where(.css-dev-only-do-not-override-6jpy1z).ant-menu-inline-collapsed >.ant-menu-item-group>.ant-menu-item-group-list>.ant-menu-item, :where(.css-dev-only-do-not-override-6jpy1z).ant-menu-inline-collapsed >.ant-menu-item-group>.ant-menu-item-group-list>.ant-menu-submenu>.ant-menu-submenu-title, :where(.css-dev-only-do-not-override-6jpy1z).ant-menu-inline-collapsed >.ant-menu-submenu>.ant-menu-submenu-title':
              {
                paddingInline: 'calc(50% - 12px - 6px)',
              },
            ['.ant-menu-inline-collapsed >.ant-menu-item .ant-menu-item-icon']:
              {
                // width: 16,
                // height: 16,
              },
          },
          ['.layout']: {
            marginLeft: 52,
            width: 'calc(100vw - 52px)',
          },
        },

        [`.slider`]: {
          backgroundColor: '#000',
          height: '100%',
          width: 230,
          position: 'fixed',
          left: 0,
          display: 'flex',
          flexDirection: 'column',
          transition: 'width 300ms',
          zIndex: 2,

          ['.ant-menu-item .ant-menu-item-icon']: {
            width: 24,
            height: 24,
            transition: 'all 300ms',
          },

          [`.logo`]: {
            color: '#fff',
            fontWeight: 520,
            flexShrink: 0,
            padding: '28px 0',
            display: 'flex',
            // paddingLeft: '12px',

            ['h1']: {
              display: 'flex',
              alignItems: 'center',
              flex: 1,
              padding: '0 10px',
              paddingLeft: 20,
              fontSize: 16,
              transition: 'all 300ms',

              ['.svg']: {
                marginRight: 12,
              },
            },
          },

          [`.menu`]: {
            flex: 1,
            overflow: 'auto',
          },
        },
        [`.layout`]: {
          background: token.colorBgLayout,
          marginLeft: 230,
          transition: 'margin 300ms',

          [`.header`]: {
            position: 'sticky',
            top: 0,
            zIndex: 3,
            borderBottom: '1px solid #eeeef3',

            [`.tools`]: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              background: '#fff',
              padding: '0 16px',
              height: 48,
              flexShrink: 0,

              [`.userinfo`]: {
                display: 'flex',
                alignItems: 'center',
                gap: 16,
              },

              [`.button-collapse`]: {
                cursor: 'pointer',
              },
            },

            [`.breadcrumb`]: {
              padding: '8px 16px',
            },
          },

          [`.content`]: {
            minHeight: '80%',
            margin: '16px',
            background: '#fff',
          },
        },
      },
    },
  ]
}

export const genUserInfoStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      borderRadius: '100px',
      background: '#FFF0F0',
      padding: '8px 12px',
      cursor: 'pointer',
      color: '#0D1121',
      fontSize: 12,
      fontWeight: 500,
    },
  },
]

export const genUserInfoMenuItemStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      backgroundColor: '#FFFFFF',
      padding: '24px',
      borderRadius: '4px',
      boxShadow: '0px 0px 4px 0px #DFE9FA, 0px 4px 8px 0px #6D86A31A',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      '.user-info-all': {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        [`.user-info`]: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          gap: '8px',
          ['.org-path-name']: {
            fontSize: '14px',
            fontWeight: 500,
            color: '#3D414D',
          },
          [`.user-name`]: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#0D1121',
          },
          [`.user-post-name, .user-phone`]: {
            fontSize: '12px',
            fontWeight: 400,
            color: '#6E707A',
          },
        },
      },
    },
  },
]
